function anotherFunction() {
  console.log('its clicked');
  if (typeof updateProgress === 'function') {
    updateProgress();
  } else {
    console.error('updateProgress is not defined yet');
  }
}
 
document.addEventListener('DOMContentLoaded', () => {
  console.log('--- Grayscale Script Initialized ---');

  const variantSelects = document.querySelector('variant-selects');
  const imageBlock = document.querySelector('.product-info__image-block');

  console.log('variantSelects found:', variantSelects);
  console.log('imageBlock found:', imageBlock);

  if (!variantSelects || !imageBlock) {
    console.warn('⚠️ Aborting: Missing <variant-selects> or .product-info__image-block in the DOM.');
    return;
  }

  const updateGrayscaleState = (event) => {
    console.log('--- Change Event Triggered ---');
    if (event) {
      console.log('Event target:', event.target);
    }

    // Find the currently checked input or selected option
    const checkedInput = variantSelects.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked, select');
    console.log('Checked input found:', checkedInput);

    if (!checkedInput) {
      console.log('⚠️ No checked input or select currently found.');
      return;
    }

    const targetTitle = imageBlock.getAttribute('data-selected-title');
    const inputValue = checkedInput.value;

    console.log(`Comparing -> Input Value: "${inputValue}" (Type: ${typeof inputValue}) vs Data Title: "${targetTitle}" (Type: ${typeof targetTitle})`);

    // Compare (trimming whitespace just in case there are invisible spaces)
    if (inputValue.trim() === targetTitle.trim()) {
      imageBlock.classList.remove('greyscale-image');
      console.log('✅ MATCH FOUND: Removed "greyscale-image" class from image block.');
    } else {
      imageBlock.classList.add('greyscale-image');
      console.log('❌ NO MATCH: Added "greyscale-image" class to image block.');
    }
  };

  // Run on initial load to set the correct state right away
  console.log('Running initial state check...');
  updateGrayscaleState();

  // Find all inputs and selects inside variant-selects
  const inputs = variantSelects.querySelectorAll('input, select');
  console.log(`Found ${inputs.length} inputs/selects to listen to inside variant-selects.`);

  inputs.forEach((input, index) => {
    console.log(`Attaching listener to input [${index}]:`, input);
    input.addEventListener('change', updateGrayscaleState);
  });
});